import api from 'connections/api';
import routes_api from 'connections/routes_api';

export const getIdentitySummary = async () => {
  const { data } = await api.get(routes_api.identity_summary);
  return data;
};

/** Aggregated instance-state dashboard: data sources, Brain structure, engines.
 * As a side effect, the backend syncs the cached snapshot consumed by
 * getAssistantCard — call this (e.g. via a refresh button) to update it. */
export const getInstanceState = async () => {
  const { data } = await api.get(routes_api.identity_state);
  return data;
};

/** Cheap, SQL-only snapshot for the accounts home module card.
 * Returns { available: false } when the profile has never been synced
 * (user hasn't opened the Identity module yet) — no GCS call either way. */
export const getAssistantCard = async () => {
  const { data } = await api.get(routes_api.identity_assistant_card);
  return data;
};

/** Per-user Identity layout + display config (instance_root, state_relpath,
 * identity_name, display_name, avatar_url). */
export const getIdentitySettings = async () => {
  const { data } = await api.get(routes_api.identity_settings);
  return data;
};

export const updateIdentitySettings = async (payload) => {
  const { data } = await api.patch(routes_api.identity_settings, payload);
  return data;
};

/** Upload assistant avatar image (JPEG/PNG/WebP, max 5MB). Field name: file */
export const uploadIdentityAvatar = async (file) => {
  const formData = new FormData();
  formData.append('file', file);
  const { data } = await api.post(routes_api.identity_settings_avatar, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return data;
};

export const deleteIdentityAvatar = async () => {
  const { data } = await api.delete(routes_api.identity_settings_avatar);
  return data;
};

export const getIdentityFiles = async () => {
  const { data } = await api.get(routes_api.identity_files);
  return data;
};

export const readIdentityFile = async (path) => {
  const { data } = await api.get(routes_api.identity_file, { params: { path } });
  return data; // { path, content }
};

export const writeIdentityFile = async (path, content) => {
  const { data } = await api.put(routes_api.identity_file, { path, content });
  return data; // { path, size_bytes, updated_at }
};

export const createIdentityFile = async (path, content) => {
  const { data } = await api.post(routes_api.identity_files, { path, content });
  return data;
};

/** Batch create/update. Accepts 201 / 207 / 403 with structured body. */
export const createIdentityFilesBatch = async (items) => {
  const { data, status } = await api.post(
    routes_api.identity_files_batch,
    items,
    { validateStatus: (s) => (s >= 200 && s < 300) || s === 403 },
  );
  return { data, status };
};

export const deleteIdentityFile = async (path) => {
  await api.delete(routes_api.identity_file, { params: { path } });
};

export const searchIdentityFiles = async (query) => {
  const { data } = await api.get(routes_api.identity_search, { params: { q: query } });
  return data;
};
